import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .ant-modal-content {\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n    padding: 28px;\n    border-radius: 4px;\n  }\n  .stack {\n    display: flex;\n    gap: 8px;\n\n    font-size: 16px;\n    letter-spacing: -0.16px;\n    line-height: 1.5;\n\n    &.success svg {\n      color: ",
        ";\n    }\n    &.caution svg {\n      color: ",
        ";\n    }\n\n    .stack {\n      flex-direction: column;\n    }\n    h4 {\n      margin-bottom: 0;\n      font-size: 20px;\n      font-weight: 700;\n      letter-spacing: -0.2px;\n    }\n    p {\n      color: ",
        ";\n    }\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n  }\n\n  .ant-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 0;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n\n      a,\n      .ant-btn {\n        width: 100%;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { Sizes, Success24Fill, Warning24Fill } from "@/components/icon/IconList";
import { Modal } from "antd";
import styled from "styled-components";
const StyledBooksOrderModal = styled(Modal).withConfig({
    componentId: "sc-92ab4c52-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_mint_300, (props)=>props.theme.new.colors.sol_red_400, (props)=>props.theme.new.colors.sol_gray_700);
const BooksOrderModal = (param)=>{
    let { children , title , severity ="success" , content , ...props } = param;
    return /*#__PURE__*/ _jsx(StyledBooksOrderModal, {
        ...props,
        closable: false,
        maskClosable: true,
        onCancel: props.onClose,
        cancelButtonProps: {
            style: {
                display: "none"
            }
        },
        okButtonProps: {
            style: {
                display: "none"
            }
        },
        children: children || /*#__PURE__*/ _jsxs("div", {
            className: "stack ".concat(severity),
            children: [
                severity === "success" && /*#__PURE__*/ _jsx(Icon, {
                    icon: Success24Fill,
                    size: Sizes.large
                }),
                severity === "caution" && /*#__PURE__*/ _jsx(Icon, {
                    icon: Warning24Fill,
                    size: Sizes.large
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "stack",
                    children: [
                        /*#__PURE__*/ _jsx("h4", {
                            children: title
                        }),
                        !!content && /*#__PURE__*/ _jsx("p", {
                            children: content
                        })
                    ]
                })
            ]
        })
    });
};
export default BooksOrderModal;
